import React, { Fragment, useEffect, useState } from "react";
import { Backdrop, CircularProgress, Container } from "@mui/material";
import CheckoutBillingAddress from "../../components/CheckoutBillingAddress";
import {
	ApiCallStatus
} from "../../utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";

import {
	fetchAddressCheckoutData,
	fetchCheckoutData,
	updateCheckoutData
} from "../PageFunctions/checkoutFunctions";
import { useArgusAuth } from "../../hooks/useArgusAuth";



const CheckoutBillingAddressPage = ({
	genericDataLoaded,
	genericPageContent
}) => {
	const {isAuthenticated, isLoading} = useArgusAuth();
	const location = useLocation();
	const navigate = useNavigate();
	const [checkoutData, setCheckoutData] = useState(null);
	const [addressCheckoutInfo, setAddressCheckoutInfo] = useState(null);
	const [countries, setCountries] = useState([]);
	const [provinces, setProvinces] = useState([]);
	const [userAddresses, setUserAddresses] = useState(null);

	const [checkoutDataCallStatus, setCheckoutDataCallStatus] = useState(ApiCallStatus.NotStarted);
	const [addressCheckoutInfoCallStatus, setAddressCheckoutInfoCallStatus] = useState(ApiCallStatus.NotStarted);
	const [updateCheckoutDataCallStatus, setUpdateCheckoutDataCallStatus] = useState(ApiCallStatus.NotStarted);

	const gotoLoginPage = () => {
		return navigate("/login", {state: {from: location}});
	};

	const gotoCheckoutSummaryPage = () => navigate("/checkout/summary");
	const gotoCreateAddressPage = () => navigate("/checkout/billing/create");



	const fetchCheckoutDataAsync = async () => {
		if (checkoutDataCallStatus === ApiCallStatus.NotStarted) {
			await fetchCheckoutData({
				setCheckoutData,
				setStatusInProgress: () => setCheckoutDataCallStatus(ApiCallStatus.InProgress),
				setStatusSuccess: () => setCheckoutDataCallStatus(ApiCallStatus.Succeeded),
				setStatusFailed: () => setCheckoutDataCallStatus(ApiCallStatus.Failed),
				setStatusError: () => setCheckoutDataCallStatus(ApiCallStatus.Error)
			});
		}
	};

	const fetchCheckoutAddressDataAsync = async () => {
		if (addressCheckoutInfoCallStatus === ApiCallStatus.NotStarted) {
			await fetchAddressCheckoutData({
				setAddressCheckoutInfo,
				setStatusInProgress: () => setAddressCheckoutInfoCallStatus(ApiCallStatus.InProgress),
				setStatusSuccess: () => setAddressCheckoutInfoCallStatus(ApiCallStatus.Succeeded),
				setStatusFailed: () => setAddressCheckoutInfoCallStatus(ApiCallStatus.Failed),
				setStatusError: () => setAddressCheckoutInfoCallStatus(ApiCallStatus.Error)
			});
		}

	};

	const updateCheckoutDataAsync = async ({checkoutData}) => {
		if (updateCheckoutDataCallStatus === ApiCallStatus.NotStarted) {
			await updateCheckoutData({
				checkoutData,
				setStatusInProgress: () => setUpdateCheckoutDataCallStatus(ApiCallStatus.InProgress),
				setStatusSuccess: () => setUpdateCheckoutDataCallStatus(ApiCallStatus.Succeeded),
				setStatusFailed: () => setUpdateCheckoutDataCallStatus(ApiCallStatus.Failed),
				setStatusError: () => setUpdateCheckoutDataCallStatus(ApiCallStatus.Error)
			});
		}
	};

	const refreshAddressOptions = async () => {
		await fetchCheckoutAddressDataAsync();
	};

	const authorizedPageLoad = async () => {

	};

	const unAuthorizedPageLoad = async () => {
		await Promise.all([
			fetchCheckoutDataAsync(),
			fetchCheckoutAddressDataAsync()
		]);
	};

	useEffect(() => {
		if (genericDataLoaded === true && isLoading === false) {
			if (isAuthenticated === false) {
				gotoLoginPage();
			}
			else {
				authorizedPageLoad();
				unAuthorizedPageLoad();
			}
		}

	}, [genericDataLoaded, isAuthenticated, isLoading]);

	useEffect(() => {
		if (!!addressCheckoutInfo) {
			let userAddressesTemp = [];
			let countries = [];
			let provinces = [];

			if (addressCheckoutInfo?.countries) {
				const countriesInAlphabeticalOrder = _.sortBy(
					addressCheckoutInfo.countries,
					({name}) => name
				);
				countries = _.sortBy(countriesInAlphabeticalOrder, ({name}) =>
					name === "South Africa" ? 0 : 1
				);
			}

			if (addressCheckoutInfo?.provinces) {
				provinces = addressCheckoutInfo.provinces;
			}

			if (addressCheckoutInfo?.userAddresses) {
				userAddressesTemp = addressCheckoutInfo.userAddresses;
			}

			setProvinces(provinces);
			setCountries(countries);
			setUserAddresses(userAddressesTemp);
		}
	}, [addressCheckoutInfo]);

	useEffect(() => {
		if (updateCheckoutDataCallStatus === ApiCallStatus.Succeeded) {
			gotoCheckoutSummaryPage();
		}
	}, [updateCheckoutDataCallStatus]);

	const allLoadingStates = [
		checkoutDataCallStatus,
		addressCheckoutInfoCallStatus,
		updateCheckoutDataCallStatus
	];

	const pageIsLoading = allLoadingStates.includes(ApiCallStatus.InProgress) || genericDataLoaded === false || isLoading === true;

	return (
		<Container maxWidth="lg">
			<CheckoutBillingAddress
				checkoutData={checkoutData}
				countries={countries}
				provinces={provinces}
				userAddresses={userAddresses}
				onSubmit={updateCheckoutDataAsync}
				refreshOptions={refreshAddressOptions}
				gotoCreateAddressPage={gotoCreateAddressPage}
			/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	);
};

export default CheckoutBillingAddressPage;
